type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface AssetReviewSubmitResult {
  submitted: number;
  skipped: number;
  errors?: string[];
}

export interface AssetReviewSubmitToast {
  level: 'success' | 'error';
  message: string;
}

export function getAssetReviewSubmitToast(t: Translate, result: AssetReviewSubmitResult): AssetReviewSubmitToast {
  const errors = result.errors || [];
  if (result.submitted === 0 && errors.length > 0) {
    return {
      level: 'error',
      message: t('review.submitFailedWithErrors', { errors: errors.join('；') }),
    };
  }

  return {
    level: 'success',
    message: result.skipped > 0
      ? t('review.submittedWithSkip', { submitted: result.submitted, skipped: result.skipped })
      : t('review.submitted', { submitted: result.submitted }),
  };
}
